import { takeEvery, put, select } from 'redux-saga/effects'

import { MessagingCreators, SocketCreators, TrackingCreators, FormsTypes, SocketTypes } from '../actions'

import { Messages } from '../Core/Socket'

import config from '../Core/Config'

export function* submitAnswer({ answer }) {
  try {
    const {
      Chat: { chatId, stage },
    } = yield select()

    /* Send answer through web socket */
    const details = {
      chatId,
      answer: {
        value: answer.value,
      },
      question: {
        id: answer.id,
      },
    }

    const answerMessage = Messages.newAnswer(details)

    yield put(SocketCreators.sendSocketMessage(answerMessage))
    if (answer.trackingCode) {
      yield put(TrackingCreators.trackAnswer(answer.trackingCode))
    }

    if (stage !== config.stages.POST_CHAT) {
      /* Display message in chat */
      if (answer.value) {
        yield put(
          MessagingCreators.displayMessage({
            text: answer.value,
            delay: config.messageDelay,
            type: 'user',
          }),
        )
      }
    }
  } catch (exception) {
    console.info(exception)
  }
}

export function* newQuestion({ result }) {
  const {
    Chat: { stage },
  } = yield select()

  const masked = result.question.pageValue === 'email'

  if (stage !== config.stages.POST_CHAT) {
    const message = {
      text: result.question.text,
      type: 'system',
      delay: 0,
      masked,
    }
    yield put(MessagingCreators.displayMessage(message))
  }
}

export default [takeEvery(SocketTypes.NEW_QUESTION, newQuestion), takeEvery(FormsTypes.SUBMIT_ANSWER, submitAnswer)]
